import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import {
  loginViaSocket,
  reloginViaSocket
} from "./HelperFunctions/socketFuntions";

import { setLocale } from "react-i18nify";

import { useTheme } from "@mui/material/styles";

import { Dlog } from "./../../utils/Dlog";

import HttpContext from "../../contexts/HTTP/HttpContext";
import KioskContext from "../../contexts/Kiosk/KioskContext";
import SocketIOContext from "../../contexts/Kiosk/SocketProvider/SocketIOContext";

import { useNavigate } from "react-router-dom";

import "./../../font.css";

//import HorizontalLayout from "./Components/ALanguageSelect/HorizontalLayout";
import { checkView } from "./HelperFunctions/viewFunctions";
import VerticalLayout from "./Components/ALanguageSelect/VerticalLayout";
import HorizontalLayout from "./Components/ALanguageSelect/HorizontalLayout";

let env = require("./../../env");
let moment = require("moment-timezone");

function NumberOfBags({ authenticate }) {
  const theme = useTheme();
  const { post } = useContext(HttpContext);

  const [loading, setLoading] = useState(false);
  const [loadingTimer, setLoadingTimer] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const [loginError, setLoginError] = useState("");

  const [qrcode, setQrcode] = useState("");

  const [intervalTimer, setIntervalTimer] = useState(null);

  const {
    //customerName,
    customerFirstName,
    customerLastName,
    customerID,
    charityName,
    charityID,
    setCustomerNameAndID,
    numBags,
    setNumBags,
    numLabels,
    setLabels,
    setSessionID,
    setAll,
    customerReset
  } = useContext(KioskContext);

  const {
    isConnected,
    socketEvents,
    qrCode,
    qrCodeExpireTime,
    syncTimeOffset,
    connect,
    disconnect,
    getSocket,
    sendEvent,
    sendQRCodeCheck,
    clearSocketEvents,
    getConfiguration,
    getKioskConfiguration,
    getKioskTheme
  } = useContext(SocketIOContext);

  const navigate = useNavigate();

  const [orientation, setOrientation] = useState(
    window.screen.orientation.type
  );

  const [targetNavigation, setTargetNavigation] = useState(null);

  useEffect(() => {
    const handleOrientationChange = () => {
      setOrientation(window.screen.orientation.type);
    };

    window.screen.orientation.addEventListener(
      "change",
      handleOrientationChange
    );

    return () => {
      window.screen.orientation.removeEventListener(
        "change",
        handleOrientationChange
      );
    };
  }, []);

  Dlog(
    "DEBUG context Dump 1",
    customerFirstName,
    customerLastName,
    customerID,
    charityName,
    charityID,
    numBags,
    numLabels
  );

  useEffect(() => {
    const kioskConfiguration = getKioskConfiguration();

    if (kioskConfiguration === null) {
      navigate("/errorscreen");
    }

    //device check
    const isWeb = true;
    if (
      (kioskConfiguration == undefined ||
        kioskConfiguration == null ||
        kioskConfiguration.enableWebClient == false ||
        kioskConfiguration.enableWebClient == "false") &&
      isWeb
    ) {
      //console.log("[ALanguageSelect] kioskConfiguration", kioskConfiguration);
      navigate("/errorscreen"); //Due to losing webAccess
    }
  }, [getKioskConfiguration()]);

  //Logic for response from Socket.IO
  useEffect(() => {
    Dlog("I think an event happened! (ALanguageSelect)", socketEvents);
    if (socketEvents == null) {
      console.log("socketEvents is null, ignoring");
      return;
    }

    let socketdata = socketEvents.data;
    Dlog("socketdata", socketdata);

    let action = socketdata.action;

    switch (action) {
      // case "QRCODE_REFRESH":
      //   console.log("TODO QRCODE_REFRESH");
      //   break;
      case "CAAPP_LOGIN":
        let newSessionID = generateSessionID();

        Dlog(
          "Got this data",
          socketdata.data.firstName,
          socketdata.data.lastName,
          socketdata.data.uniqueID,
          socketdata.data.languagePreference
        );

        if (socketdata.data.languagePreference == "en") {
          setLocale("en");
        }

        if (socketdata.data.languagePreference == "fr") {
          setLocale("fr");
        }

        setAll(
          socketdata.data.firstName, //customerFirstName
          socketdata.data.lastName, //customerLastName
          socketdata.data.uniqueID, //customerID
          null, //charityName
          null, //charityID
          null, //numBags
          null, //numLabels
          null, //labelsList
          newSessionID //sessionID
        );

        navigate("/numbags"); //skip phonenumber input
        clearSocketEvents();
        break;
      case "RELOGIN":
        reloginViaSocket(getSocket(), "ALANGUAGESELECT");
        break;

      case "REQUESTCHARITIESINFO_DATA":
        Dlog("[DEBUG] SOCKET EVENT: REQUESTCHARITIESINFO_DATA");
        Dlog("Got this data", socketdata.data);

        //check if the format is correct
        if (socketdata.data.lastUpdated && socketdata.data.charities) {
          sessionStorage.setItem(
            "charitiesJSON",
            JSON.stringify(socketdata.data)
          );
        }

        if (loadingTimer) {
          clearTimeout(loadingTimer);
          setLoadingTimer(null);
        }

        navigate(targetNavigation);
        setLoading(false);
        break;

      case "REQUESTCHARITIESINFO_NOCHANGE":
        Dlog("[DEBUG] SOCKET EVENT: REQUESTCHARITIESINFO_NOCHANGE");

        if (loadingTimer) {
          clearTimeout(loadingTimer);
          setLoadingTimer(null);
        }

        navigate(targetNavigation);
        setLoading(false);
        break;

      case "REQUESTCHARITIESINFO_ERROR":
        Dlog("[DEBUG] SOCKET EVENT: REQUESTCHARITIESINFO_ERROR");

        if (loadingTimer) {
          clearTimeout(loadingTimer);
          setLoadingTimer(null);
        }

        setLoading(false);
        console.log("ERROR?");
        break;
    }
  }, [socketEvents]);

  const navigateNext = event => {
    if (!loading) {
      setLoading(true);
      const timerId = setTimeout(() => {
        setLoading(false);
        setLoadingTimer(null);
      }, 15000);
      setLoadingTimer(timerId);

      generateNewSessionID();
      //navigate("/phonenumber");
      setTargetNavigation("/phonenumber");

      const charitiesJSON = getFromSessionStorage("charitiesJSON", null);

      console.log(
        "[DEBUG] charitiesJSON",
        charitiesJSON,
        charitiesJSON?.lastUpdated
      );

      const payload = {
        type: "REQUESTCHARITIESINFO",
        payload: {
          lastUpdated: charitiesJSON?.lastUpdated ?? null
          //entries: kioskID
        }
      };

      console.log("ALanguageSelect payload", payload);

      sendEvent(payload, () => {
        console.log("onEventSent");
      });
    }
  };

  const navigateDonate = event => {
    if (!loading) {
      setLoading(true);
      const timerId = setTimeout(() => {
        setLoading(false);
        setLoadingTimer(null);
      }, 15000);
      setLoadingTimer(timerId);

      generateNewSessionID();
      //navigate("/donation");
      setTargetNavigation("/donation");

      const charitiesJSON = getFromSessionStorage("charitiesJSON", null);

      console.log(
        "[DEBUG] charitiesJSON",
        charitiesJSON,
        charitiesJSON?.lastUpdated
      );

      const payload = {
        type: "REQUESTCHARITIESINFO",
        payload: {
          lastUpdated: charitiesJSON?.lastUpdated ?? null
          //entries: kioskID
        }
      };

      console.log("ALanguageSelect payload", payload);

      sendEvent(payload, () => {
        console.log("onEventSent");
      });
    }
  };

  const generateNewSessionID = () => {
    let newSessionID = generateSessionID();

    setAll(
      null, //customerFirstName
      null, //customerLastName
      null, //customerID
      null, //charityName
      null, //charityID
      null, //numBags
      null, //numLabels
      null, //labelsList
      newSessionID //sessionID
    );
  };

  const generateNewSessionIDAndNavigateNext = () => {
    generateNewSessionID();

    navigate("/phonenumber");
  };

  const isNotMobile = useMediaQuery("(min-width:600px)");
  const isLandscape = useMediaQuery("(orientation:landscape)");

  // if (
  //   orientation == "landscape-primary" ||
  //   orientation == "landscape-secondary"
  // ) {
  if (checkView(orientation, getKioskTheme()) == "horizontal") {
    return (
      <HorizontalLayout
        nextFunc={navigateNext}
        loading={loading}
        isNotMobile={isNotMobile}
        getKioskConfiguration={getKioskConfiguration}
      />
    );
  } else {
    return (
      <VerticalLayout
        nextFunc={navigateNext}
        donationFunc={navigateDonate}
        loading={loading}
        isNotMobile={isNotMobile}
        getKioskConfiguration={getKioskConfiguration}
      />
    );
  }
}

function generateSessionID() {
  let newSessionID = null;
  if (crypto.randomUUID != null) {
    newSessionID = crypto.randomUUID();
  } else {
    // in the case of http, randomUUID is not available; This case should be used on the servers, as the servers should redirect to https.
    console.log(
      "[WARNING] crypto.randomUUID doesn't exist, HTTPS is probably not enabled. Using fallback."
    );
    newSessionID = mockUniqueID(32);
  }
  return newSessionID;
}

function mockUniqueID(length) {
  let chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var result = "";
  for (var i = length; i > 0; --i)
    result += chars[Math.floor(Math.random() * chars.length)];
  return result;
}

function getFromSessionStorage(key, defaultValue = null) {
  try {
    const item = sessionStorage.getItem(key);
    if (item === null) return defaultValue;

    // Try to parse as JSON, fall back to string if it fails
    return JSON.parse(item);
  } catch (error) {
    console.warn(`Error parsing SessionStorage item "${key}":`, error);
    return defaultValue;
  }
}

export default NumberOfBags;
